export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manawub.65ff6a8a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};